export default __webpack_public_path__ + "static/media/tag-blue.d44d0512.svg";